import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Location extends ApplicationRecord {
  static jsonapiType = "locations";

  @Attr() adminVisible: boolean;

  @Attr() countryCode: string;

  @Attr() latitude: number;

  @Attr() longitude: number;

  @Attr() name: string;

  @BelongsTo() parent: Location;

  @Attr() parentId: number;

  @Attr() timeZone: string;

  @Attr() type: string;

  @Attr() visible: boolean;
}

export default Location;
